angular.module('TurneroApp').component('coGruposAlta', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '='
    },
    controller: [
        'gruposService',
        'utilsService',
        'TurneroAppConstant',
        function (gruposService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.grupoAlta = {};
            ctrl.listaPuestosAlta = [];

            ctrl.errores = {
                Puestos: false,
                N_Grupo: false,
            };

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadAlta = function () {
                    ctrl.grupoAlta = {};
                    ctrl.listaPuestosAlta = [];

                    ctrl.errores = {
                        Puestos: false,
                        N_Grupo: false,
                    };

                    gruposService.getInfo({
                        'id_Grupo': ' ',
                        'id_centro_atencion': ctrl.centroAtencionSeleccionado.id
                    }).$promise.then(function (data) {
                        ctrl.grupoAlta = data
                    }).catch(function (error) {
                        utilsService.errores(error);
                    });
                }
            }

            ctrl.cambiosEnPuestos = function () {
                ctrl.grupoAlta.Id_Puesto_Alta = '';

                if (ctrl.listaPuestosAlta.length > 1) {
                    for (var i = 0; i < ctrl.listaPuestosAlta.length; i++) {
                        ctrl.grupoAlta.Id_Puesto_Alta = ctrl.grupoAlta.Id_Puesto_Alta.length ? ctrl.grupoAlta.Id_Puesto_Alta + ',' + ctrl.listaPuestosAlta[i].id.toString() : ctrl.listaPuestosAlta[i].id.toString();
                        ctrl.errores.Puestos = false;
                    }
                } else {
                    ctrl.errores.Puestos = true;
                }
            };

            ctrl.guardarGrupoNuevo = function () {
                ctrl.errores.N_Grupo = !(ctrl.grupoAlta.N_Grupo);
                ctrl.grupoAlta.Id_Centro_Atencion = ctrl.centroAtencionSeleccionado.id
                ctrl.errores.Puestos = !(ctrl.grupoAlta.Id_Puesto_Alta)

                if (ctrl.errores.N_Grupo || ctrl.errores.Puestos) {
                    return;
                }

                if (ctrl.grupoAlta.Id_Puesto_Alta.length > 0) {
                    gruposService.save(ctrl.grupoAlta).$promise.then(function (res) {
                        ctrl.ctrlPadre.grillaReload();
                        sweetAlert("Alta Grupo", "El grupo se registró correctamente", "success");
                    }).catch(function (req) {
                        utilsService.errores(req);
                    });

                };
            };

            ctrl.cancelar = function () {
                ctrl.ctrlPadre.grillaReload();
            }
        }
    ],
    template: require('./gruposAlta.html')
});


// WEBPACK FOOTER //
// ./app/components/grupos/gruposAltaComponent.js